import {CheckCircleFilled, CloseOutlined} from '@ant-design/icons';
import {Button, Modal, Radio, Typography} from 'antd';
import React, {Fragment, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {drawerZIndex} from '../../../constants/Common';

const {Text} = Typography;

const ESGFrameworkConfirmation: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({open, onClose}) => {
  const [selectedFramework, setSelectedFramework] = useState<string>('BRSR');
  const navigate = useNavigate();

  const frameworks = [
    {
      label: 'BRSR – Business Responsibility and Sustainability Report',
      value: 'BRSR'
    },
    {
      label: 'GRI – Global Reporting Initiative',
      value: 'GRI'
    },
    {
      label: 'TCFD – Task Force on Climate-related Financial Disclosures',
      value: 'TCFD'
    }
  ];

  const handleConfirm = () => {
    onClose();
    navigate('/peerBenchmarking');
  };

  return (
    <Modal
      title={'ESG Framework for Peer Benchmarking'}
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={600}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <Text className="sub-title">
        To begin peer benchmarking, please select one ESG framework from the
        options below.
      </Text>

      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <Text strong>Choose a Framework to Proceed</Text>
        <br />
        <div
          style={{backgroundColor: '#fff', padding: '15px', marginTop: '10px'}}
        >
          <Text style={{fontSize: 14, fontWeight: '600'}}>
            Available Frameworks:
          </Text>

          <Radio.Group
            onChange={(e) => {
              setSelectedFramework(e.target.value);
            }}
            value={selectedFramework}
            style={{display: 'flex', flexDirection: 'column', marginTop: 12}}
          >
            {frameworks.map((fw) => (
              <Fragment key={fw.value}>
                {selectedFramework !== fw.value && (
                  <Radio
                    key={fw.value}
                    value={fw.value}
                    style={{marginTop: 10, marginBottom: 10}}
                  >
                    {fw.label}
                  </Radio>
                )}
                {selectedFramework === fw.value && (
                  <span
                    style={{display: 'flex', marginTop: 10, marginBottom: 10}}
                  >
                    <CheckCircleFilled
                      style={{color: '#52c41a', fontSize: 20}}
                    />
                    <Text style={{marginLeft: '5px'}}>{fw.label}</Text>
                  </span>
                )}
              </Fragment>
            ))}
          </Radio.Group>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px'
        }}
      >
        <Button onClick={onClose} style={{marginRight: 12}}>
          Cancel <CloseOutlined style={{marginLeft: 8}} />
        </Button>
        <Button
          type="primary"
          style={{backgroundColor: '#435B37', borderColor: '#435B37'}}
          onClick={handleConfirm}
        >
          Confirm & Continue →
        </Button>
      </div>
    </Modal>
  );
};

export default ESGFrameworkConfirmation;
